module.exports = __webpack_public_path__ + "img/ic-action-increase.afa6a53f.svg";